import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useUploadForecast } from '@futrli/shared-services/excel-upload/excel-modals/hooks/use-upload-forecast';

import { useCreateForecast } from './useCreateForecast';

export const useCreateOrUploadForecast = (workspaceId: string, organisationId: string) => {
  const intl = useIntl();

  const { createForecast, isSaving, data: newForecast, error, reset } = useCreateForecast();
  const {
    createForecastFromExcelFile,
    isInProgress: isSavingExcel,
    errorMessage: errorExcel,
    createdForecastId: newExcelForecastId,
    setErrorMessage: setExcelErrorMessage
  } = useUploadForecast(workspaceId, organisationId);

  const standardErrorText = intl.formatMessage({
    id: 'predict.create_forecast.try_again',
    defaultMessage: 'Try again'
  });

  // If we start creating a normal forecast, clear any previous excel upload errors
  useEffect(() => {
    if (isSaving) {
      setExcelErrorMessage('');
    }
  }, [isSaving, setExcelErrorMessage]);

  // If we start creating an excel forecast, clear any previous normal forecast errors
  useEffect(() => {
    if (isSavingExcel) {
      reset();
    }
  }, [isSavingExcel, reset]);

  return {
    createForecast,
    createForecastFromExcelFile,
    isSaving: isSaving || isSavingExcel,
    error: error ? standardErrorText : errorExcel,
    newForecastId: newForecast?.id || newExcelForecastId
  };
};
